import { createContext, useContext, useMemo } from 'react';
import type { CompanyReportSection } from '../../useSection';

interface ContextValue {
  section?: CompanyReportSection;
}

const ReportSectionContext = createContext<ContextValue | undefined>(undefined);

export function useReportSection() {
  const context = useContext(ReportSectionContext);
  if (context === undefined) {
    return {};
  }
  return context;
}

interface Props {
  children: React.ReactElement;
  section: CompanyReportSection;
}
const ReportSectionProvider = (props: Props) => {
  const { section } = props;
  const value = useMemo(() => ({ section }), [section]);

  return (
    <ReportSectionContext.Provider value={value}>
      {props.children}
    </ReportSectionContext.Provider>
  );
};
export default ReportSectionProvider;
